export default (app) => {
  const layouts = require.context('@/__vue2stone/layouts/', true, /\.vue$/i);
  layouts.keys().map(key => app.component(key.split('/').pop().split('.')[0], layouts(key).default));
}